import {useController, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {useEffect, useState} from "react";
import type {FocusEvent} from "react";
import {StoreServiceGenInfoFormFieldsType} from "../types";
import {StoreServiceGenInfoNameFormFieldProps} from "./types";
import {FormField, FormFieldError} from "../../../../../design-system/form-field";

export function ServiceGenInfoNameFormField({
  id,
  label,
  placeholder,
}: StoreServiceGenInfoNameFormFieldProps) {
  const {control} = useFormContext<StoreServiceGenInfoFormFieldsType>();

  const {field, fieldState} = useController({
    name: "name",
    control,
  });
  const fieldValue = field.value as string | undefined;

  const [nameValue, setNameValue] = useState<string | undefined>(fieldValue);

  useEffect(() => {
    setNameValue(fieldValue);
  }, [fieldValue]);

  function handleBlur(e: FocusEvent<HTMLInputElement, Element>) {
    field.onChange(e);
    field.onBlur();
  }

  function handleChange(e: FocusEvent<HTMLInputElement, Element>) {
    setNameValue(e.target.value);
  }

  return (
    <div>
      <FormField
        id={id}
        label={label}
        renderInput={(id) => (
          <Space direction="vertical" size={16} style={{display: "flex"}}>
            <Input
              id={id}
              status={fieldState.error?.message ? "error" : ""}
              value={nameValue}
              onChange={handleChange}
              onBlur={handleBlur}
              size="large"
              placeholder={placeholder}
              ref={field.ref}
            />
            <FormFieldError errorMessage={fieldState.error?.message} />
          </Space>
        )}
      />
    </div>
  );
}
